<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import {ref,onMounted} from 'vue';
	
	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		//styleId: String,
		link: String,
		linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		rowValue: String
	});
		
	const {hasLink, tdStyle} = useBasePrinter(props);
	
	const theLink = ref(null);

	function printValue(value): string {	
		if (value) {
			return value.replaceAll("&quot;", "\"").replaceAll("&hellip;", "...");
		}
		else {
			return "";
		}
	}

	onMounted(() => {
		if (theLink.value) {
			crm.initPreviewFor(theLink.value);
		}
	});
</script>
<template> 
	<td :class="styleClass" :style="[sortStyle, tdStyle]">
		<a v-if="hasLink" :href="link" :target="linkTarget" ref="theLink">{{printValue(value)}}</a>
		<template v-else>{{printValue(value)}}</template>
	</td>
</template>
